import { VideoService } from './types'

export const defaultYoutubeParams = {
  autoplay: 0,
  mute: 0,
  controls: 1,
  playsinline: 1,
  showinfo: 0,
  rel: 0,
  iv_load_policy: 3,
  modestbranding: 1,
  enablejsapi: 1,
}

export const defaultVimeoParms = {
  mute: 0,
  controls: 1,
  background: 0,
}

export const getIframeSrc = (
  videoId: string,
  params: { [key: string]: number | string } = {},
  service: VideoService,
) => {
  if (service === 'youtube') {
    return Object.entries({
      ...defaultYoutubeParams,
      ...params,
    }).reduce(
      (src, [key, val]) => `${src}&${key}=${encodeURIComponent(val)}`,
      `https://www.youtube.com/embed/${videoId}?`,
    )
  }

  return Object.entries({
    ...defaultVimeoParms,
    ...params,
  }).reduce(
    (src, [key, val]) => `${src}&${key}=${encodeURIComponent(val)}`,
    `https://player.vimeo.com/video/${videoId}?`,
  )
}
